module.exports = __webpack_public_path__ + "img/imagen3.68c9e449.png";